import script from "./AnnualReviewDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualReviewDetails.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=adc795ec&scoped=true&lang=css&external"
import "@/assets/css/grid.css?vue&type=style&index=1&id=adc795ec&scoped=true&lang=css&external"
import "./AnnualReviewDetails.vue?vue&type=style&index=2&id=adc795ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adc795ec"]])

export default __exports__